<div class="header">
  <h4>Tick&Live Connect</h4>
  <button type="button" appButton variant="outline" icon="plus" (click)="ajouterType()">Ajouter un Service</button>
</div>

@for (famille of familles(); track famille.nom) {
  <app-connect-famille [famille]="famille.nom" [natures]="famille.natures"></app-connect-famille>
}
